<template>
  <div>
    <div v-if="errored" class="errored">Une erreur s'est produite 😥</div>

    <div v-else-if="loaded" id="material-dark-projects" :class="'resume ' + person.lang">
      <div class="banner">
        <div class="content-left">
          <img v-if="person.picture" :src="person.picture" class="profile" />
        </div>
        <div class="content-right">
          <h1>{{ person.name.first }} {{ person.name.last }}</h1>
          <span class="position"
            >{{ person.position }}<span v-if="person.birth.year"> — {{ lang.born }} {{ person.birth.year }}</span></span
          >
        </div>
      </div>

      <div class="container">
        <div class="content-left">
          <section class="contact">
            <h2>{{ lang.contact }}</h2>
            <ul>
              <li v-if="person.contact.street">
                <i class="fa fa-home"></i>
                {{ person.contact.street }}, {{ person.contact.city }}
              </li>
              <li>
                <i class="fa fa-envelope"></i>
                <a :href="contactLinks.email">{{ person.contact.email }}</a>
              </li>
              <li>
                <i class="fa fa-phone"></i>
                <a :href="'tel:' + person.contact.phone">{{ person.contact.phone }}</a>
              </li>
              <li v-if="person.contact.website">
                <i class="fa fa-globe"></i>
                <a :href="person.contact.website" target="_blank">{{ person.contact.website }}</a>
              </li>
              <li v-if="person.contact.github">
                <i class="fa fa-github"></i>
                <a :href="contactLinks.github" target="_blank">{{ person.contact.github }}</a>
              </li>
            </ul>
          </section>
          <section class="skills">
            <h2>{{ lang.skills }}</h2>
            <ul>
              <li v-for="skill in person.skills">
                <span>{{ skill.name }}</span>
                <span class="skill-bar">
                  <span :style="'width: ' + skill.level + '%'" class="level"></span>
                </span>
              </li>
            </ul>
          </section>
        </div>

        <div class="content-center">
          <section v-if="person.experience.length" class="experience">
            <h2>{{ lang.experience }}</h2>
            <div v-for="experience in person.experience" class="item">
              <h3>
                {{ experience.position }}<br />
                <span class="company">{{ experience.company }}</span
                ><br />
                <span class="timeperiod">{{ experience.timeperiod_from }} - {{ experience.timeperiod_to || lang.today }}</span>
              </h3>
              <div v-if="experience.description" class="description">{{ experience.description }}</div>
            </div>
          </section>
          <section v-if="person.education.length" class="education">
            <h2>{{ lang.education }}</h2>
            <div v-for="education in person.education" class="item">
              <h3>
                {{ education.degree_role }}<br />
                <span class="company">{{ education.degree_structure }}</span
                ><br />
                <span class="timeperiod">{{ education.timeperiod }}</span>
              </h3>
              <div v-if="education.description" class="description">{{ education.description }}</div>
            </div>
          </section>
        </div>

        <div class="content-right">
          <section v-if="person.projects.length" class="projects">
            <h2>{{ lang.projects }}</h2>
            <div v-for="project in person.projects" class="item">
              <h3>
                {{ project.name }}<br />
                <span class="company">{{ project.platform }}</span
                ><br />
                <span class="timeperiod">{{ project.timeperiod_from }} - {{ project.timeperiod_to }}</span>
              </h3>
              <div v-if="project.description" class="description">{{ project.description }}</div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div v-else class="loading">Chargement en cours ⏰</div>
  </div>
</template>

<script>
import Vue from 'vue';
import { getVueOptions } from './options';

const name = 'material-dark-projects';
export default Vue.component(name, getVueOptions(name));
</script>

<style lang="less" scoped>
@page cool-rtl {
  margin: 0;
}

@primary-color: #512da8;
@secondary-color: #673ab7;
@third-color: #ede7f6;
@normal: 16px;
@big: 34px;
@medium: 20px;
@small: 14pt;

#material-dark-projects {
  position: relative;
  color: #000;
  background-color: @third-color;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: @normal;
  line-height: 1.2;
  page: material-dark-projects;
  .ar& {
    direction: rtl;
    font-family: 'Noto Sans Arabic', 'Brown', sans-serif;
    font-weight: 400;
  }

  .banner {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    align-items: center;
    column-gap: 0.3cm;
    margin-right: 0.3cm;

    .content-left {
      grid-column-start: 1;
      grid-column-end: 5;
      background-color: @primary-color;
      color: @secondary-color;
    }

    .content-right {
      grid-column-start: 5;
      grid-column-end: 13;
    }

    .profile {
      width: 100%;
      height: auto;
      vertical-align: middle;
    }

    h1 {
      font-size: @big;
      letter-spacing: -0.25px;
      line-height: 1;
      margin-top: 0;
      margin-bottom: 5px;
      font-weight: 300;
      .ar& {
        font-weight: 400;
      }
    }

    .position {
      font-weight: 300;
      .ar& {
        font-weight: 400;
      }
    }
  }

  .container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 0.3cm;
    margin-right: 0.3cm;

    .content-left {
      background-color: @primary-color;
      color: @third-color;
    }
  }

  section {
    margin: 1cm 0;
  }

  .item {
    background-color: #fff;
    padding: 0.5cm;
    border-radius: 4px;
    border: 1px solid rgba(49, 27, 146, 0.1);
    page-break-inside: avoid;
    break-inside: avoid;

    &:not(:last-child) {
      margin: 0.3cm 0;
    }
  }

  h2 {
    font-size: @medium;
    letter-spacing: 0.15px;
    margin-top: 0;
    margin-bottom: 0.3cm;
    font-weight: 300;
    .ar& {
      font-weight: 400;
    }
  }

  h3 {
    font-size: @normal;
    font-weight: 400;
    margin: 0;
    .ar& {
      font-weight: 500;
    }
  }

  .description {
    white-space: pre-line;
  }

  .timeperiod {
    text-transform: capitalize;
  }

  .contact {
    padding: 0 0.5cm;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      a {
        color: @third-color;
        text-decoration: none;
      }
    }
  }

  .skills {
    padding: 0 0.5cm;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        display: grid;
        grid-template-columns: max-content 1fr;
        align-items: center;
        column-gap: 1cm;
      }

      .skill-bar {
        display: flex;
        background-color: @secondary-color;
        height: 5px;
        border-radius: 3px;
        overflow: hidden;
      }

      .level {
        background-color: @third-color;
        height: 100%;
      }
    }
  }
}
</style>
